<template>
  <v-menu
    v-model="contextMenu.show"
    absolute
    close-on-click
    close-on-content-click
    class="context-menu"
    :position-x="contextMenu.position.x"
    :position-y="contextMenu.position.y"
  >
    <v-list>
      <template v-for="(action, actionIndex) in actions">
        <v-list-item
          v-if="action.label && action.action"
          :key="actionIndex"
          @click.stop="() => { action.action(contact, group); contextMenu.show = false; }"
        >
          {{ action.label }}
        </v-list-item>
        <v-divider :key="actionIndex" v-else />
      </template>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'SmsContextMenu',

  data() {
    return {
      actions: [],
      contact: {
        type: Object,
        default: () => {
          return {};
        }
      },
      group: {
        type: Object,
        default: () => {
          return null;
        }
      },
      contextMenu: {
        show: false,
        position: {
          x: 0,
          y: 0
        }
      }
    };
  },

  created() {
    this.$root.$on('open-context-menu', this.openContextMenu);
  },

  beforeDestroy() {
    this.$root.$off('open-context-menu');
  },

  methods: {
    openContextMenu(menuOptions) {
      this.contact = menuOptions.contact;
      this.group = menuOptions.group;
      this.actions = menuOptions.actions;
      this.contextMenu.position.x = menuOptions.positionX;
      this.contextMenu.position.y = menuOptions.positionY;
      this.contextMenu.show = true;
    }
  }
};
</script>

<style>
.context-menu {
  z-index: 100;
}
</style>
